import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CheckStreamConnectionMutation } from "../graphql/mutations";
import type {
  CheckStreamConnectionMutationType,
  CheckStreamConnectionMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCheckStreamConnectionMutation = (
  options?: MutationHookOptions<
    CheckStreamConnectionMutationType,
    CheckStreamConnectionMutationVariablesType
  >
) => {
  return useMutation<
    CheckStreamConnectionMutationType,
    CheckStreamConnectionMutationVariablesType
  >(CheckStreamConnectionMutation, options);
};
